import { BasePayloadMapper } from '@ps/utils';

import { McTraditionalSurveyPayloadDto } from '../../dtos/mc-traditional.payload.dto';
import { SurveyMetadataForm } from '../../models';
import {
  StandardSurveyPayloadInput,
  StandardSurveyPayloadMapper,
} from '../standard-survey-payload-mapper/standard-survey.payload.mapper';

export interface McTraditionalSurveyPayloadInput
  extends StandardSurveyPayloadInput {
  mcUniqueId: string;
  isParent: boolean;
}

const MC_TITLE_SUFFIX = / - MC-[^-\s]+-[^-\s]+$/;

function baseMcTraditionalTitle(title: string): string {
  return title.replace(MC_TITLE_SUFFIX, '');
}

export function mcTraditionalSurveyTitle(metadata: SurveyMetadataForm): string {
  const countryCode = metadata.selectedCountries[0] ?? '';
  const languageShortCode = metadata.selectedLanguages[0] ?? '';
  return `${baseMcTraditionalTitle(metadata.title)} - MC-${countryCode}-${languageShortCode}`;
}

export class McTraditionalSurveyPayloadMapper extends BasePayloadMapper<
  McTraditionalSurveyPayloadInput,
  McTraditionalSurveyPayloadDto
> {
  private readonly _standardMapper = new StandardSurveyPayloadMapper();

  public toPayload(
    input: McTraditionalSurveyPayloadInput,
  ): McTraditionalSurveyPayloadDto {
    return {
      ...this._standardMapper.toPayload(input),
      survey_title: mcTraditionalSurveyTitle(input.metadata),
      mc_unique_id: input.mcUniqueId,
      mc_parent: input.isParent,
    };
  }
}
